module.exports = __webpack_public_path__ + "img/17-3-en.fad04ccf.png";